import React from 'react'
import PropTypes from 'prop-types'
import { filter, isNil, values } from 'lodash'

import { FormDropdown } from 'components/form/dropdown/FormDropdown'
import { FormCheckbox } from 'components/form/checkbox/FormCheckbox'
import { FormInput } from 'components/form/input/FormInput'
import { MONTH_LIST } from 'utils/enums/months'
import { Error } from 'components/error/Error'

import styles from './EmploymentDates.module.scss'

export const EmploymentDates = ({ formData, handleFieldChange }) => {
  const errorsList = [
    formData.employmentFromMonthOverride.error,
    formData.employmentFromYearOverride.error,
    formData.employmentToMonthOverride.error,
    formData.employmentToYearOverride.error,
  ]

  const activeErrors = filter(errorsList, item => !isNil(item) && item !== '')
  const shouldShowError = !!activeErrors.length

  return (
    <div className={styles.container}>
      <div className={styles.blocks}>
        <div className={styles.block}>
          <FormDropdown
            className={styles.monthDropdown}
            showErrorText={false}
            rowWidth={175}
            title="Employed From"
            placeholder="Month"
            items={values(MONTH_LIST)}
            field={formData.employmentFromMonthOverride}
            onChange={handleFieldChange('employmentFromMonthOverride')}
          />
          <FormInput
            className={styles.yearInputBlock}
            inputClassName={styles.yearInput}
            showErrorText={false}
            type="text"
            maxLength={4}
            placeholder="Year"
            validationPattern={value => !isNaN(value) || value === ''}
            field={formData.employmentFromYearOverride}
            onChange={handleFieldChange(`employmentFromYearOverride`)}
          />
        </div>
        <div className={styles.block}>
          <FormDropdown
            isDisabled={formData.employmentStillWorksHereOverride.value}
            className={styles.monthDropdown}
            rowWidth={175}
            title="Employed To"
            showErrorText={false}
            placeholder="Month"
            items={values(MONTH_LIST)}
            field={formData.employmentToMonthOverride}
            onChange={handleFieldChange('employmentToMonthOverride')}
          />
          <FormInput
            isDisabled={formData.employmentStillWorksHereOverride.value}
            className={styles.yearInputBlock}
            inputClassName={styles.yearInput}
            showErrorText={false}
            type="text"
            maxLength={4}
            placeholder="Year"
            validationPattern={value => !isNaN(value) || value === ''}
            field={formData.employmentToYearOverride}
            onChange={handleFieldChange(`employmentToYearOverride`)}
          />
        </div>
      </div>

      <div className={styles.blocks}>
        <div className={styles.block} />
        <div className={styles.block}>
          <FormCheckbox
            title="Applicant currently works here"
            field={formData.employmentStillWorksHereOverride}
            onChange={value => {
              handleFieldChange(`employmentStillWorksHereOverride`)(value)
              handleFieldChange('employmentToMonthOverride')(null)
              handleFieldChange('employmentToYearOverride')(null)
            }}
          />
        </div>
      </div>
      {shouldShowError && <Error>{activeErrors[0]}</Error>}
    </div>
  )
}

EmploymentDates.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
